// extracted by mini-css-extract-plugin
export var closed = "_gv-1";
export var resizer = "_gv-0";